import { render, staticRenderFns } from "./FaqManagement.vue?vue&type=template&id=0724c2b4&scoped=true&"
import script from "./FaqManagement.vue?vue&type=script&lang=js&"
export * from "./FaqManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0724c2b4",
  null
  
)

export default component.exports